import React, { useState } from 'react';
import { FaBan } from 'react-icons/fa';

function KillSwitchButton({ business, onKillSwitch }) {
  const [showModal, setShowModal] = useState(false);
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (!reason.trim()) {
      alert('Səbəb daxil edin!');
      return;
    }

    setLoading(true);
    await onKillSwitch(business.id, reason);
    setLoading(false);
    setShowModal(false);
    setReason('');
  };

  return (
    <>
      <button onClick={() => setShowModal(true)} style={styles.killBtn} title="Deaktiv et">
        <FaBan /> Kill Switch
      </button>

      {/* Modal */}
      {showModal && (
        <>
          <div style={styles.overlay} onClick={() => setShowModal(false)}></div>
          <div style={styles.modal}>
            <div style={styles.modalHeader}>
              <h3 style={styles.modalTitle}>⚠️ XƏBƏRDARLIQ</h3>
            </div>

            <div style={styles.modalBody}>
              <p style={styles.businessName}>
                <strong>{business.name}</strong>
              </p>
              <p style={styles.warningText}>
                Bu business-i deaktiv etmək istədiyinizdən əminsiniz?
              </p>
              <p style={styles.infoText}>
                Deaktiv edildikdən sonra bu business mobile app-də görünməyəcək və istifadəçilər
                check-in edə bilməyəcək.
              </p>

              <div style={styles.inputGroup}>
                <label style={styles.label}>Səbəb:</label>
                <textarea
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  placeholder="Deaktiv etmə səbəbini qeyd edin..."
                  style={styles.textarea}
                  rows={4}
                />
              </div>
            </div>

            <div style={styles.modalFooter}>
              <button
                onClick={() => setShowModal(false)}
                style={styles.btnCancel}
                disabled={loading}
              >
                Xeyr, Ləğv Et
              </button>
              <button onClick={handleConfirm} style={styles.btnConfirm} disabled={loading}>
                {loading ? 'Deaktiv edilir...' : 'Bəli, Deaktiv Et'}
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
}

const styles = {
  killBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    padding: '8px 12px',
    backgroundColor: '#F44336',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: '600',
    transition: 'all 0.3s',
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    zIndex: 1000,
  },
  modal: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    borderRadius: '16px',
    width: '90%',
    maxWidth: '500px',
    zIndex: 1001,
    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)',
  },
  modalHeader: {
    padding: '25px',
    borderBottom: '2px solid #F0F0F0',
    textAlign: 'center',
  },
  modalTitle: {
    fontSize: '22px',
    fontWeight: 'bold',
    color: '#F44336',
    margin: 0,
  },
  modalBody: {
    padding: '25px',
  },
  businessName: {
    fontSize: '18px',
    color: '#1A1A2E',
    marginBottom: '15px',
    textAlign: 'center',
  },
  warningText: {
    fontSize: '15px',
    color: '#1A1A2E',
    marginBottom: '10px',
    fontWeight: '600',
  },
  infoText: {
    fontSize: '13px',
    color: '#666',
    marginBottom: '20px',
    lineHeight: '1.6',
  },
  inputGroup: {
    marginBottom: '20px',
  },
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: '600',
    color: '#1A1A2E',
    marginBottom: '8px',
  },
  textarea: {
    width: '100%',
    padding: '12px',
    fontSize: '14px',
    border: '2px solid #E0E0E0',
    borderRadius: '8px',
    outline: 'none',
    resize: 'vertical',
    fontFamily: 'inherit',
  },
  modalFooter: {
    padding: '20px 25px',
    borderTop: '2px solid #F0F0F0',
    display: 'flex',
    gap: '15px',
    justifyContent: 'flex-end',
  },
  btnCancel: {
    padding: '12px 24px',
    backgroundColor: '#E0E0E0',
    color: '#1A1A2E',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s',
  },
  btnConfirm: {
    padding: '12px 24px',
    backgroundColor: '#F44336',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s',
  },
};

export default KillSwitchButton;